//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "FabRightMenuSwitch",
    props: {
        options: { type: Array },
        value: { type: String },
        mini: { type: Boolean }
    },
    data() {
        return {
            localValue: null
        };
    },
    computed: {
        isLeft() {
            return this.options[0].value === this.localValue;
        },
        toggleClass() {
            return ["toggle", this.isLeft ? null : "right"];
        },
        leftClass() {
            return this.isLeft ? "active" : null;
        },
        rightClass() {
            return this.isLeft ? null : "active";
        },
        labelLeft() {
            return this.options[0].label;
        },
        labelRight() {
            return this.options[1].label;
        }
    },
    watch: {
        value: {
            handler(val) {
                this.localValue = val;
            },
            immediate: true
        }
    },
    methods: {
        onClickLeft() {
            this.localValue = this.options[0].value;
            this.update();
        },
        onClickRight() {
            this.localValue = this.options[1].value;
            this.update();
        },
        update() {
            setTimeout(() => {
                this.$emit("update", this.localValue);
            }, 200);
        }
    }
};
